module.exports = __webpack_public_path__ + "img/property_age_white.6a88894.svg";